<div class="row" role="tablist" *ngIf="showFaqList && showFaqList.length">
  <div *ngFor="let item of showFaqList; let idx = index" class="col-md-12 col-xs-12">
    <p-accordion [multiple]="true" id="p-accordion-default-9">
      <p-accordionTab id="accordion-tab-with-child" [selected]="false">
        <p-header>
          <div class="row n-p">
            <div class="col-11 title">
              <p for="title" [innerHTML]="item.question"></p>
            </div>
          </div>
        </p-header>
        <div class="p-content">
          <div class="row blade blade-right border-t">
            <div class="col-12">
              <p for="title" class="m-t-sm" [innerHTML]="item.answer"></p>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
